export const userSiteConstants = {
  REQUEST_USER_SITE_SUCCESS: 'REQUEST_USER_SITE_SUCCESS',
  REQUEST_USER_SITE_FAILURE: 'REQUEST_USER_SITE_FAILURE',
  REQUEST_USER_SITE_LOADING: 'REQUEST_USER_SITE_LOADING',
  UPDATE_SELECTED_SITES: 'UPDATE_SELECTED_SITES',
  SET_USER_CURRENT_SITE: 'SET_USER_CURRENT_SITE'
};

const requestUserSiteSuccess = (userData) => {
  return { type: userSiteConstants.REQUEST_USER_SITE_SUCCESS, payload: userData };
};

const requestUserSiteloading = (userData) => {
  return { type: userSiteConstants.REQUEST_USER_SITE_LOADING, payload: userData };
};

const requestUserSiteFailure = (error) => {
  return { type: userSiteConstants.REQUEST_USER_SITE_FAILURE, payload: error };
};

const UpdateSelectedSites = (data) => {
  return { type: userSiteConstants.UPDATE_SELECTED_SITES, payload: data };
};

const setUserCurrentSite = (data) => {
  return { type: userSiteConstants.SET_USER_CURRENT_SITE, payload: data };
};

export const userSite = {
  requestUserSiteSuccess,
  requestUserSiteFailure,
  requestUserSiteloading,
  UpdateSelectedSites,
  setUserCurrentSite
};
